import { useMediaQuery } from 'src/hooks/helpers/useMediaQuery';

export const useIsMobile: () => boolean = () => {
  return useMediaQuery('(max-width: 519px)');
};
